import React, { useContext } from "react";
import useDateFormat from "toolkit/useDateFormat";
import CertificationContext from "module/certification/context/CertificationContext";
import { CertificationInterface } from "module/certification/types";
import CertificationCompletionStartDateTimeLabelField from "./CertificationCompletionStartDateTimeLabelField";

const CertificationCompletionStartDateTimeFieldContainer: React.FC = () => {
  const { entity } = useContext(CertificationContext);
  const { formatDateTime } = useDateFormat();

  const { completionStartDate } = entity as CertificationInterface;

  return (
    <CertificationCompletionStartDateTimeLabelField
      {...{ completionStartDate, formatDateTime }}
    />
  );
};

export default React.memo(CertificationCompletionStartDateTimeFieldContainer);
